// extracted by mini-css-extract-plugin
export var option = "_bs-0";
export var optionCard = "_bs-f";
export var optionContent = "_bs-g";
export var optionIcon = "_bs-i";
export var optionIconBox = "_bs-h";
export var optionLabel = "_bs-j";
export var optionPill = "_bs-m";
export var optionPillBadge = "_bs-p";
export var optionPillIcon = "_bs-n";
export var optionPillLabel = "_bs-o";
export var optionRadio = "_bs-k";
export var optionRadioInner = "_bs-l";
export var optionReveal = "_bs-2";
export var optionRevealDelay0 = "_bs-3";
export var optionRevealDelay1 = "_bs-4";
export var optionRevealDelay10 = "_bs-d";
export var optionRevealDelay11 = "_bs-e";
export var optionRevealDelay2 = "_bs-5";
export var optionRevealDelay3 = "_bs-6";
export var optionRevealDelay4 = "_bs-7";
export var optionRevealDelay5 = "_bs-8";
export var optionRevealDelay6 = "_bs-9";
export var optionRevealDelay7 = "_bs-a";
export var optionRevealDelay8 = "_bs-b";
export var optionRevealDelay9 = "_bs-c";
export var optionSelected = "_bs-1";